/**
 * An optimized H4 component.
 *
 * @param props
 * @returns h4
 */
export const H4: React.FC<JSX.IntrinsicElements["h4"]> = (props) => {
  return (
    <h4
      {...props}
      className={`text-[23px] leading-[30px] font-circular ${props.className}`}
    >
      {props.children}
    </h4>
  )
}
